<template>
  <div v-if="!noScriptHidden">
    <noscript>
      <img
        height="1"
        width="1"
        style="display:none"
        :src="`https://www.facebook.com/tr?id=${pixelId}&ev=${event}&noscript=1`"
      />
    </noscript>
  </div>
</template>

<script>
/* global fbq */
export default {
  name: "MetaPixel",
  props: {
    pixelId: {
      type: String,
      default: "1518694192133915",
    },
    event: {
      type: String,
      default: "PageView",
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    noScriptHidden: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    // Evita carregar mais de uma vez
    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );

      fbq("init", this.pixelId);
    }

    // Envia o evento e parâmetros
    fbq("track", this.event, this.params);
  },
};
</script>
